import { render, staticRenderFns } from "./AutoGamResolutionTab.vue?vue&type=template&id=4c8965dc"
import script from "./AutoGamResolutionTab.vue?vue&type=script&lang=js"
export * from "./AutoGamResolutionTab.vue?vue&type=script&lang=js"
import style0 from "./AutoGamResolutionTab.vue?vue&type=style&index=0&id=4c8965dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports